import reduxCatch from 'redux-catch';
import Logger from 'circe/logger';

export const errorHandler = (error, getState, lastAction, dispatch) => {
  console.error(error);
  console.debug('current state', getState && getState());
  console.debug('last action was', lastAction);
  Logger.exception(error);
};

export const catcher = () => reduxCatch(errorHandler);

const middlewares = [];

if (false && __DEV__) {
  const freeze = require('redux-freeze');
  middlewares.push(freeze);
  middlewares.push(require('redux-logger').default);
}

export default middlewares;
